import { Injectable, Optional, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AddressModel } from '../models/address.model';
import { ClassModel } from '../models/class.model';
import { ClassLevelModel } from '../models/classlevel.model';
import { ActivityModel } from '../models/crm-model/activity.model';
import { ConnectionModel } from '../models/crm-model/connection.model';
import { InstructorModel } from '../models/instructor.model';
import { LessonModel } from '../models/lesson.model';
import { RoleModel } from '../models/role.model';
import { StudentModel } from '../models/student.model';
import { TenantModel } from '../models/tenant.model';
// import { PostType } from 'src/app/core/models/post-type.model';
// import { PostTypeService } from './post-type.service';

@Injectable({
  providedIn: 'root'
})
export class DataStateService {
  //https://medium.com/@tomastrajan/how-to-get-route-path-parameters-in-non-routed-angular-components-32fc90d9cb52

  private groupState = new BehaviorSubject(null);
  group: Observable<any> = this.groupState.asObservable();

  private trainingState = new BehaviorSubject(null);
  training: Observable<any> = this.trainingState.asObservable();

  private participantState = new BehaviorSubject(null);
  participant: Observable<any> = this.participantState.asObservable();

  private companyState = new BehaviorSubject(null);
  company: Observable<string> = this.companyState.asObservable();
  private testState = new BehaviorSubject(null);
  test: Observable<string> = this.testState.asObservable();
  private vakaState = new BehaviorSubject(null);
  vaka: Observable<string> = this.vakaState.asObservable();
  private documentState = new BehaviorSubject(null);
  document: Observable<string> = this.documentState.asObservable();
  private assessmentDocumentState = new BehaviorSubject(null);
  assessmentDocument: Observable<string> = this.assessmentDocumentState.asObservable();
  private selectAssessmentTemplateState = new BehaviorSubject(null);
  selectAssessmentTemplate: Observable<string> = this.selectAssessmentTemplateState.asObservable();

  constructor() {
    
  }

  reloadGroup() {
    this.groupState.next(null);
  }

  reloadTraining() {
    this.trainingState.next(null);
  }

  reloadParticipant() {
    this.participantState.next(true);
  }

  reloadCompany() {
    this.companyState.next(null);
  }

  reloadTest() {
    this.testState.next(null);
  }
  reloadVaka() {
    this.vakaState.next(null);
  }
  reloadDocument() {
    this.documentState.next(null);
  }

  reloadAssessmentDocument() {
    this.assessmentDocumentState.next(null);
  }
  reloadSelectAssessmentTemplate() {
    this.selectAssessmentTemplateState.next(null);
  }

}
